<template>
  <section
    class="no-padding"
    :class="{
      'designs-fullscreen': designs,
      'website-fullscreen': website
    }"
  >
    <div class="designs">
      <router-link
        tag="a"
        class="h3 main-button"
        to="/projects/designs"
        @mouseenter.native="designs = true"
        @mouseleave.native="designs = false"
        >designs</router-link
      >
    </div>
    <div class="website">
      <router-link
        tag="a"
        class="h3 main-button"
        to="/projects/websites"
        @mouseenter.native="website = true"
        @mouseleave.native="website = false"
        >websites</router-link
      >
    </div>
  </section>
</template>

<script>
import { EventBus } from "../main";
export default {
  data() {
    return {
      designs: false,
      website: false
    };
  },
  mounted() {
    EventBus.$emit("allLinks", document.querySelectorAll("a, .target"));
  }
};
</script>

<style lang="scss" scoped>
.no-padding {
  height: 100vh;
  position: relative;
  // background: linear-gradient(60deg, black 50%, rgb(0, 91, 196) 50%);
  padding: 0 !important;

  &::after,
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s all ease;
  }

  &::after {
    background: url(../assets/img/design.jpg) center center;
    background-size: cover;
    clip-path: polygon(35% 0%, 100% 0%, 100% 100%, 65% 100%);
    opacity: 0.4;
  }

  &::before {
    background: url(../assets/img/websites.jpg) center center;
    background-size: cover;
    clip-path: polygon(0% 0%, 35% 0%, 65% 100%, 0% 100%);
    opacity: 0.4;
  }

  &.designs-fullscreen {
    &::after {
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    }
    &::before {
      clip-path: polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%);
    }
  }

  &.website-fullscreen {
    &::after {
      clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%);
    }
    &::before {
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    }
  }

  .designs,
  .website {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
    transition: 0.5s all ease;
  }
}
</style>
